import React from 'react';
import ReactDOM from 'react-dom';
import {param} from '../lib/param';
import {SliderPanel} from './sliders/slider-panel';
import {base64Decode} from './utils/base64Decode';

export class LoadMore {
    constructor(button, content) {
        this.button = button;
        this.content = content;

        this.disableLoading = false;

        if(this.button && this.content) {
            this.events();
        }
    }

    hideButton() {
        this.button.classList.add('hide');
    }

    startLoadingAnimation() {
        this.button.classList.add('loading');
    }

    stopLoadingAnimation() {
        this.button.classList.remove('loading');
    }

    insertNewContent(htmlString) {
        const newContent = document.createRange().createContextualFragment(htmlString);
        this.content.insertBefore(newContent, this.button.parentNode);

        const elemSliders = document.querySelectorAll('.react-slider-panel');
        if(elemSliders.length > 0) {
            Array.prototype.forEach.call(
                Array.from(elemSliders),
                (elemSlider) => {
                    const sliderData = JSON.parse(base64Decode(elemSlider.dataset.slider));
                    ReactDOM.render(<SliderPanel sliderdata={sliderData}/>, elemSlider);
                }
            )
        }
    }

    errorMessage(status) {
        alert('Request failed.  Returned status of ' + status);
    }

    sendPost() {
        const data = {
            'action': 'loadmore',
            'postsPerPage': gewobacc_params.posts_per_page,
            'page' : gewobacc_params.current_page,
            'home': gewobacc_params.is_home,
            'taxQuery': JSON.stringify(gewobacc_params.tax_query)
        };

        const xhr = new XMLHttpRequest();

        xhr.open('POST', gewobacc_params.ajaxurl, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.onload = function() {
            this.stopLoadingAnimation();

            if (xhr.status === 200) {
                if(xhr.responseText && 0 != xhr.responseText) {
                    gewobacc_params.current_page++;
                    if(gewobacc_params.current_page ==  gewobacc_params.max_num_pages) {
                        this.hideButton();
                    }
                    this.insertNewContent(xhr.responseText);
                } else {
                    this.hideButton();
                }
            } else {
                this.errorMessage(xhr.status);
            }
            this.disableLoading = false;
        }.bind(this);
        xhr.send(param(data));
    }

    clickButton(event) {
        event.preventDefault();
        if(!this.disableLoading ) {
            this.disableLoading = true;
            this.startLoadingAnimation();
            this.sendPost();
        }
        return false;
    }

    events() {
        this.button.addEventListener("mouseup", this.clickButton.bind(this), false);
        this.button.addEventListener("touchend", this.clickButton.bind(this), false);
    }
}